import WindowDetailV001 from "../../Portal/Accessor/Element/V001/WindowDetail";
import DoorDetailV001 from "../../Portal/Accessor/Element/V001/DoorDetail";
import OpaqueLouvreDetailV001 from "../../Portal/Accessor/Element/V001/OpaqueLouvreDetail";
import ExternalWallDetailV001 from "../../Portal/Accessor/Element/V001/ExternalWallDetail";
import InternalWallDetailV001 from "../../Portal/Accessor/Element/V001/InternalWallDetail";
import FloorCeilingDetailV001 from "../../Portal/Accessor/Element/V001/FloorCeilingDetail";
import RoofDetailV001 from "../../Portal/Accessor/Element/V001/RoofDetail";
import ExternalScreenDetailV001 from "../../Portal/Accessor/Element/V001/ExternalScreenDetail";
import InfiltrationPenetrationDetailV001 from "../../Portal/Accessor/Element/V001/InfiltrationPenetrationDetail";
import Elements from "../../Portal/Accessor/Element/Elements";
import ElementsNew from "../../Portal/Accessor/Element/ElementsNew";
import RoofWindowDetailV001 from "../../Portal/Accessor/Element/V001/RoofWindowDetail";
import SkylightDetailV001 from "../../Portal/Accessor/Element/V001/SkylightDetail";
import MultipleExternalWallsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleExternalWallsDetail";
import MultipleInternalWallsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleInternalWallsDetail";
import MultipleFloorCeilingsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleFloorCeilingsDetail";
import MultipleRoofsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleRoofsDetail";
import MultipleDoorsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleDoorsDetail";
import MultipleOpaqueLouvresDetailV001 from "../../Portal/Accessor/Element/V001/MultipleOpaqueLouvresDetail";
import MultipleWindowsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleWindowsDetail";
import MultipleSkylightsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleSkylightsDetail";
import MultipleRoofWindowsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleRoofWindowsDetail";
import MultipleInfiltrationPenetrationsDetailV001 from "../../Portal/Accessor/Element/V001/MultipleInfiltrationPenetrationsDetail";
import MultipleExternalScreensDetailV001 from "../../Portal/Accessor/Element/V001/MultipleExternalScreensDetail";

const AccessorElementRouters = [
    {
      path: "ElementAssessor/Detail/Window/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <WindowDetailV001/>,
      title: "Window | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/Door/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <DoorDetailV001/>,
      title: "Door | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/OpaqueLouvre/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <OpaqueLouvreDetailV001/>,
      title: "Opaque Louvre | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/ExternalScreen/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <ExternalScreenDetailV001/>,
      title: "External Screen | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/InfiltrationPenetrationInExternalWall/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <InfiltrationPenetrationDetailV001 elementType="InfiltrationPenetrationInExternalWall"/>,
      title: "Infiltration & Penetration | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/InfiltrationPenetrationInRoof/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <InfiltrationPenetrationDetailV001 elementType="InfiltrationPenetrationInRoof" />,
      title: "Infiltration & Penetration | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/ExternalWall/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <ExternalWallDetailV001/>,
      title: "External Wall | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/InternalWall/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <InternalWallDetailV001/>,
      title: "Internal Wall | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/Floor/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <FloorCeilingDetailV001 elementType="Floor"/>,
      title: "Floor | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/Ceiling/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <FloorCeilingDetailV001 elementType="Ceiling"/>,
      title: "Ceiling | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/Roof/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <RoofDetailV001/>,
      title: "Roof | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Elements/:designVariationVersionName/:developmentId/:projectId/:designVariationId",
      exact: true,
      requireAuth: true,
      element: <Elements/>,
      title: "Elements | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/ElementsNew/:designVariationVersionName/:developmentId/:projectId/:designVariationId",
      exact: true,
      requireAuth: true,
      element: <ElementsNew/>,
      title: "Elements | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/InfiltrationPenetrationInCeiling/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <InfiltrationPenetrationDetailV001 elementType="InfiltrationPenetrationInCeiling" />,
      title: "Infiltration & Penetration | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/RoofWindow/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <RoofWindowDetailV001 elementType="RoofWindowInRoof" />,
      title: "Roof Window | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/Detail/Skylight/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:elementId/:parentId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <SkylightDetailV001 />,
      title: "Skylight | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/ExternalWall/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleExternalWallsDetailV001 />,
      title: "External Walls | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/InternalWall/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleInternalWallsDetailV001 />,
      title: "Internal Walls | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/Floor/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleFloorCeilingsDetailV001 elementType="Floor" />,
      title: "Floors | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/Ceiling/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleFloorCeilingsDetailV001 elementType="Ceiling" />,
      title: "Ceilings | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/Roof/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleRoofsDetailV001 />,
      title: "Roofs | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/Door/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleDoorsDetailV001 />,
      title: "Doors | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/OpaqueLouvre/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleOpaqueLouvresDetailV001 />,
      title: "Roof Windows | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/Window/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleWindowsDetailV001 />,
      title: "Windows | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/Skylight/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleSkylightsDetailV001 />,
      title: "Skylights | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/RoofWindow/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleRoofWindowsDetailV001 />,
      title: "Roof Windows | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/InfiltrationPenetration/:elementType/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleInfiltrationPenetrationsDetailV001 />,
      title: "Infiltration & Penetrations | AccuRate Enterprise",
    },
    {
      path: "ElementAssessor/MultipleDetail/ExternalScreen/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:zoneId/:jsonParamHex/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <MultipleExternalScreensDetailV001 />,
      title: "External Screens | AccuRate Enterprise",
    }
  ];
export default AccessorElementRouters;